import { createAsyncThunk } from "@reduxjs/toolkit";
import {getPetTypesStart, getPetTypesSuccess, getPetTypesFailure
} from "../reducers/getPetTypesReducer";
import axios from "axios";
import Cookies from "js-cookie";
import { getToken } from "./getToken";

export const getPetTypess = createAsyncThunk(
    "getPetTypes",
    async (_, thunkAPI) => {
        try {
            thunkAPI.dispatch(getPetTypesStart());
            const token = Cookies.get("token");

            const response = await axios.get(
                `${process.env.REACT_APP_BASE_URL}api/PetInsurance/GetPetTypes`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const responseData = await response;

            thunkAPI.dispatch(getPetTypesSuccess(responseData?.data?.result));

            return responseData;
        } catch (error) {
            thunkAPI.dispatch(getPetTypesFailure(error.response.data.Message));
            if (error.response && error.response.status === 401) {
                Cookies.remove("token");

                thunkAPI.rejectWithValue({ unauthorized: true });
                await thunkAPI.dispatch(getToken());
            }
            throw error;
        }
    }
);